<div class="selected-slot-container">
    <div class="selected-slot-title">
        <div *ngFor="let title of getSlotTileArray()">{{ title }}</div>
        <div class="slot-info"></div>
        <div class="terminals-info">
            {{ getActiveTerminalsText() }}
        </div>
    </div>

    <div class="filter-container-wrapper">
        <ng-container *ngIf="filterCondition && filterCondition != FILTER_UNDEFINED">
            <mat-icon
                svgIcon="close"
                class="icon"
                style="color: #1f6873; cursor: pointer"
                (click)="updateFilter($event, FILTER_UNDEFINED)" />
        </ng-container>
        <div
            class="filter-icon-container"
            [class.showFilterSelected]="showFilterOptions"
            (click)="showFilterOptions = !showFilterOptions; $event.stopPropagation()">
            <mat-icon svgIcon="filter-icon" class="icon" />
            <div>{{ 'output-settings.DO.filter.title' | translate }}</div>
            <mat-radio-group class="filter-container" *ngIf="showFilterOptions">
                <mat-radio-button
                    class="filter-row"
                    [checked]="filterCondition == FILTER_EMTPY"
                    [value]="filterCondition == FILTER_EMTPY"
                    (click)="updateFilter($event, FILTER_EMTPY)">
                    {{ 'output-settings.DO.filter.empty' | translate }}
                </mat-radio-button>

                <mat-radio-button
                    class="filter-row"
                    [checked]="filterCondition == FILTER_ACTIVE"
                    [value]="filterCondition == FILTER_ACTIVE"
                    (click)="updateFilter($event, FILTER_ACTIVE)">
                    {{ 'output-settings.DO.filter.active' | translate }}
                </mat-radio-button>

                <mat-radio-button
                    class="filter-row"
                    [checked]="filterCondition == FILTER_ALARM"
                    [value]="filterCondition == FILTER_ALARM"
                    (click)="updateFilter($event, FILTER_ALARM)">
                    {{ 'output-settings.DO.filter.alarm' | translate }}
                </mat-radio-button>

                <mat-radio-button
                    class="filter-row"
                    [checked]="filterCondition == FILTER_ON_OFF"
                    [value]="filterCondition == FILTER_ON_OFF"
                    (click)="updateFilter($event, FILTER_ON_OFF)">
                    {{ 'output-settings.DO.filter.on-off' | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>

<div class="body-container">
    <ng-container *ngIf="!isLoadingTerminals; else terminalsSpinner">
        <div class="digital-row table-header">
            <div class="column terminal-no">
                {{ 'output-settings.DO.header.terminal' | translate }}
            </div>
            <div class="column status">
                {{ 'output-settings.DO.header.status' | translate }}
            </div>
            <div class="column channel">
                {{ 'output-settings.DO.header.channels' | translate }}
            </div>
            <div class="column output-type">
                {{ 'output-settings.DO.header.output-type' | translate }}
            </div>
            <div class="column col-options">
                <mat-icon
                    svgIcon="more-options"
                    class="icon"
                    style="cursor: pointer"
                    (click)="showOptions = !showOptions; $event.stopPropagation()" />
                <div class="options-container" *ngIf="showOptions">
                    <div class="option-row">
                        <mat-icon svgIcon="delete" class="small-icon" />
                        <div (click)="deleteAllChannels()">
                            {{ 'output-settings.DO.table.delete-all' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngFor="let setting of displaySettings" class="digital-row">
            <div class="column terminal-no semibold">
                {{ setting.terminalNum }}
            </div>
            <div class="column status" [class.emptyStatus]="!setting.channels[0]">
                {{ getStatusString(setting) | translate }}
            </div>
            <div class="column channel">
                {{ getChannelText(setting) }}
            </div>
            <div class="column output-type">
                {{ getOutputType(setting) }}
            </div>
            <div class="column col-options" (click)="openSetting(setting)">
                <mat-icon class="small-icon" svgIcon="chevron-right" />
            </div>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="!isLoadingTerminals">
    <div class="table-footer">
        <div class="footer-button" (click)="movePage(-1)" [class.disabled]="currentPage == 0">
            <mat-icon class="paginator-icon chevron-left" svgIcon="chevron-right" />
        </div>
        <div class="footer-button" (click)="movePage(1)" [class.disabled]="currentPage == maxNumPages">
            <mat-icon class="paginator-icon" svgIcon="chevron-right" />
        </div>
        <div>{{ getFooterText() }}</div>
    </div>
</ng-container>

<ng-template #terminalsSpinner>
    <app-loading-spinner class="terminals-spinner" strokeWidth="2"></app-loading-spinner>
</ng-template>
